import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

const CommunitySwitcher = () => {
  return (
    <Dropdown>
      <Dropdown.Toggle variant="primary" className="me-3 btn-sm">
        Select Community <FontAwesomeIcon icon={faCaretDown} />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item>Alista</Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item>Arbor Vista </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item>Cedars</Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item>Lochwood Manor</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

CommunitySwitcher.propTypes = {};

export default CommunitySwitcher;
